import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function AlphaNumericalValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const /** @type {?} */ pattern: any = /^[a-z0-9]+$/i;

    if (control.value && !pattern.test(control.value)) {
      return { alphaNumeric: { value: control.value } };
    }

    return null;
  };
}
